import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-style-one',
  templateUrl: './contact-style-one.component.html',
  styleUrls: ['./contact-style-one.component.scss']
})
export class ContactStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
